export enum AgentOperatingModeEnum {
  /** Free format */
  FREE_MODE = 'FREE_MODE',
  /** FRM knowledge base */
  FRM_MODE = 'FRM_MODE',
}